export default "__VITE_ASSET__70e08ea0__"